import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import FormFieldBuilderWorkspace from "./FormFieldBuilderWorkspace";
import FormFieldBuilderErrors from "./FormFieldBuilderErrors";
import I18n from "i18n-js";
// import I18n from "i18n-js";

export default class FormFieldBuilder extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = { 
      active_tab: 'general',
      count: this.props.field_options.length || 0,
      order: [],
      errors: this.props.errors ? this.props.errors : {},
      loading: false,
      options:  this.props.field_options ? this.props.field_options : [],
      field: this.props.field || '',
      field_type: this.props.type || 'please_select_one',
      required: this.props.required || false,
      rating_scale_label: this.props.rating_scale_label || '',
      rating_range: this.props.rating_range || "",
      emoji_rating_label: this.props.emoji_rating_label || '',
      selected: false,
      selected_rating: '',
      is_new: this.props.is_new || false,
      display_only_text: this.props.display_only_text ? this.props.display_only_text : "",
      form_type: this.props.form_type || '',
    }

    this.onChange = this.onChange.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChangeField = this.onChangeField.bind(this)
    this.onChangeType = this.onChangeType.bind(this)
    this.onChangeRequired = this.onChangeRequired.bind(this)
    this.onChangeStatus = this.onChangeStatus.bind(this)
    this.onClickAddOption = this.onClickAddOption.bind(this)
    this.onClickRemoveOption = this.onClickRemoveOption.bind(this)
    this.onChangeOption = this.onChangeOption.bind(this)
    this.onChangeOrder = this.onChangeOrder.bind(this)
    this.onChangeRatingRange = this.onChangeRatingRange.bind(this)
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this)
    // this.onChangeRichText = this.onChangeRichText.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  /** Render Functions **/

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]
    return (
      <div className="FormFieldBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <FormFieldBuilderWorkspace
            {...this.props} 
            {...this.state} 
            onChangeField={this.onChangeField} 
            onChangeRequired={this.onChangeRequired}
            onChangeStatus={this.onChangeStatus} 
            onChangeType={this.onChangeType} 
            onChangeOption={this.onChangeOption}
            onChangeOrder={this.onChangeOrder}
            onClickAddOption={this.onClickAddOption}
            onClickRemoveOption={this.onClickRemoveOption}
            onChangeRatingRange={this.onChangeRatingRange}
            onChangeSelectedRating={this.onChangeSelectedRating}
            onChange={this.onChange}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />  
      </div>
    );
  };

  tabs(){
    if(this.state.field_type === 'numbered_scale') {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.generalErrors(this.state.errors).length,
          },
          {
            tabName: I18n.t('numbered_scale'),
            targetName: 'rating_scale',
            classes: this.state.active_tab === 'rating_scale' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.ratingScaleErrors(this.state.errors).length,
          },
        ]
      )  

    }
    if(this.state.field_type === 'emoji_rating') {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.generalErrors(this.state.errors).length,
          },
          {
            tabName: I18n.t('emoji_rating'),
            targetName: 'emoji_rating',
            classes: this.state.active_tab === 'emoji_rating' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.ratingScaleErrors(this.state.errors).length,
          },
        ]
      )  

    }
    if (this.state.field_type === 'select_box') {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.generalErrors(this.state.errors).length,
          },
          {
            tabName: I18n.t('options'),
            targetName: 'options',
            classes: this.state.active_tab === 'options' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }, 
        ]
      )  
    }
    if (this.state.field_type === 'display_only') {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.generalErrors(this.state.errors).length,
          },
          {
            tabName: I18n.t('display_only'),
            targetName: 'display_only',
            classes: this.state.active_tab === 'display_only' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }, 

        ]
      )

    } else {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FormFieldBuilderErrors.generalErrors(this.state.errors).length,
          },
        ]
      );
    };
  };

  /** Change Handlers **/

  onChange(name, event) {
    this.state[name] =
      event && event.target && typeof event.target.value !== "undefined"
        ? event.target.value
        : event;
    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }
  
  onChangeField(event) {
    if (event && event.target) {
      var state = $.extend(true, {}, this.state);
      state[event.target.name] = event.target.value;
      this.setState(state);
    }
  }

  onChangeType(event) {
    this.setState({field_type: event.target.value, form_type: event.target.selectedOptions[0].getAttribute('form_type')})
  }

  onChangeRequired(event) {
    this.setState({required: event.target.checked})
  }

  onChangeStatus(event) {
    this.setState({status: event})
  }

  onChangeOption(event) {
    let fieldOptions = this.state.options
    fieldOptions.map((option, idx) => {
      if(option.position == event.target.id) {
        fieldOptions[idx] = {
          position: parseInt(event.target.id),
          option: event.target.value,
        }
      }
    })
    this.setState({options: fieldOptions})
  }

  onClickAddOption() {
    var options = this.state.options
    var count = this.state.count
    count += 1
    options.push({
      position: count,
      option: ""
    })

    this.setState({
      options: [...options],
      count: count,
    })
  }

  onClickRemoveOption(event){
    var newOptions = this.state.options
    newOptions = newOptions.filter(option => option.position != event.target.id)
    newOptions.map((option, idx) => {
      newOptions[idx] =  {
        position: idx + 1,
        option: option.option, 
      }
    })
    this.setState({
      options: newOptions,
      count: this.state.count - 1 
    })
  }

  onChangeOrder(idsInOrder) {
    this.setState({order:idsInOrder})
  }

  onChangeRatingRange(event) {
    if (event.target.value == "") {

      var range = ""
    } else {
      var range = event.target.value
    }
    this.setState({rating_range: range})
  }

  onChangeSelectedRating(rating) {
    this.setState({
      selected: !this.state.selected,
      selected_rating: rating
    });
  }

  // onChangeRichText = (name, richText) => {
  //   var display_only = Object.assign({}, this.state.display_only);
  //   display_only[name] = richText;
  //   this.setState({ display_only: display_only });
  // };


  /** AJAX Calls **/

  onSubmit() {
    var self = this
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new ? self.props.create_path : self.props.save_path,
        data: {
          form_field: {
            field: self.state.field,
            required: self.state.required,
            field_type: self.state.field_type != 'please_select_one' ?  self.state.field_type : null,
            display_only_text: self.state.display_only_text,
            form_type: self.state.form_type,
          },
          order: self.state.order,
          field_options: JSON.stringify(self.state.options),
     
          rating_scale: {
            rating_scale_label: self.state.rating_scale_label,
            rating_range: self.state.rating_range
          },
          emoji_scale: {
            emoji_rating_label: self.state.emoji_rating_label,
            emoji_range: self.state.range_range
          }, 
       

        } 
      }).done(function (data) {
        if(Object.keys(data.errors).length) {
          self.setState({
            errors: data.errors,
            loading: false
          })
        } else {
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('form_field_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('form_field_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }  
      }).catch((data) => {
        if (data && data.responseJSON) {
          self.setState({errors: data.responseJSON, loading: false})
          $('.modal-body').scrollTop(0)
        }
      })
    }, 1000)
  };
};
